import { render, staticRenderFns } from "./TransfersControllers.vue?vue&type=template&id=62582492&scoped=true&"
import script from "./TransfersControllers.vue?vue&type=script&lang=js&"
export * from "./TransfersControllers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62582492",
  null
  
)

export default component.exports